<template src="./template.html"></template>
<style lang="scss">@import 'style';</style>

<script>
    /* eslint-disable no-console, no-new */

    import { mapGetters } from 'vuex';
    import { AUTH } from '../../../store/types';

    export default {
        name: 'login',
        computed: {
            ...mapGetters(['get_auth_status', 'get_auth_error', 'show_login_error']),
        },
        data () {
            return {
                form: {
                    email: '',
                    password: '',
                },
                rules: {
                    email: [
                        { required: true, message: 'E-mail wird benötigt' },
                        { type: 'email', message: 'E-mail nicht gültig' },
                    ],
                    password: [
                        { required: true, message: 'Password wird benötigt' },
                    ],
                },
            };
        },
        methods: {
            login (formName) {
                const { email, password } = this.form;

                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.$store.dispatch(`${AUTH.namespace}${AUTH.REQUEST}`, { email, password })
                            .then(() => {
                                // After current user is retrieved, continue
                                this.$store.dispatch(`${AUTH.namespace}${AUTH.CURRENT_USER}`).then(() => {
                                    this.$router.replace('orders');
                                });
                            })
                            .catch((err) => {
                                throw err;
                            });
                    }
                });
            },
        },
    };

</script>



// WEBPACK FOOTER //
// src/components/pages/login/Login.vue